// extracted by mini-css-extract-plugin
module.exports = {"container":"subscriberMenu_container__h8jkT"};